import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  rowFormatter,
  placColumns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './BuildingReportUtils';


const PlaceBuildingReportPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.placeBuildingReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url === "/blocksReportPlaces")) {
    const temp = menuList.find(q => q.url === "/blocksReportPlaces")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/blocksReportPlaces"
            render={props =>
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/blocksReportPlaces"
                api="api/Place"
                getFunctionName="GetPlacesReport"
                exportfuncName="GetExcelPlacesReport"
                currentState={currentState}
                columns={placColumns}
                prepareFilter={prepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
                haveStimulsoftReport={true}
                mrtUrl="/reports/PlaceBlockReports.mrt"
                jsonFileName="GetPlacesReport"
              />
            }
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default PlaceBuildingReportPage



